import {RequestUser} from '../resources/RequestUser';
import {DomainEvent} from './DomainEvent';

export class EntityExportAvailableEvent<ResourceClass> extends DomainEvent<ResourceClass[]> {

  /**
   * An optional key to identify the purpose of the origin export.
   */
  readonly context?: string;

  constructor(
    event: string,
    data: ResourceClass[],
    timestamp?: Date | undefined,
    context?: string | undefined,
    principal?: RequestUser | undefined,
    attempt?: number
  ) {
    super(event, data, timestamp, principal, attempt);
    this.context = context;
  }
}

